// Libs
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
import { BaseLabel } from '~/components/common';
// Others
import { IBaseOption } from '~/utils/interface/common';
// Styles, images, icons
import styles from './BaseChoose.module.scss';

type Props<T> = {
  value?: string;
  label?: string;
  option?: T[];
  defaultSelected?: T | null;
  iconLabel?: string;
  required?: boolean;
  errorMessage?: string;
  onChange?: (selectedValue: T | null) => void;
};

const cx = classNames.bind(styles);

const BaseChoose = <T extends IBaseOption>(props: Props<T>) => {
  //#region Destructuring Props
  const { value, label, iconLabel, defaultSelected, option, required, errorMessage, onChange } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [selectedValue, setSelectedValue] = useState<T | null>(null);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (!option?.length) return;

    const compareValue = value ?? defaultSelected?.value;

    if (!compareValue) {
      setSelectedValue(null);
      return;
    }

    const matched = option?.find((item) => String(item.value) === String(compareValue));

    if (matched) {
      setSelectedValue(matched);
    } else if (defaultSelected) {
      setSelectedValue(defaultSelected);
    } else {
      setSelectedValue({
        label: compareValue,
        value: compareValue,
      } as T);
    }
  }, [value, defaultSelected, option]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleOptionChange = (value: T) => {
    setSelectedValue(value);
    onChange && onChange(value);
  };

  //#endregion Handle Function

  return (
    <Stack id='baseChooseComponent' className={cx('container')}>
      {label && <BaseLabel icon={iconLabel} label={label} required={required} />}

      <div className={cx('body')}>
        <Stack direction={'row'} gap={4}>
          {option &&
            option?.map((item, index) => {
              return (
                <Box
                  className={cx('item', selectedValue?.value === item?.value && 'selectedValue')}
                  width={'auto'}
                  key={index}
                  onClick={() => handleOptionChange(item)}
                >
                  {item.label}
                </Box>
              );
            })}
        </Stack>

        {errorMessage && <Typography className={cx('errMessage')}>{errorMessage}</Typography>}
      </div>
    </Stack>
  );
};

export default BaseChoose;
